module.exports = __webpack_public_path__ + "static/media/468x60_0054_en.80a98cfc.jpg";